import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const routeTitles = {
  "/": "Shree ambika global",
  "/about": "Shree ambika global - About Us",
  "/products": "Shree ambika global - Shop",
  "/shop-list": "Shree ambika global - Shop List",
  "/product-details": "Shree ambika global - Product Details",
  "/product-grouped": "Shree ambika global - Product Grouped",
  "/product-sidebar": "Shree ambika global - Product Sidebar",
  "/cart": "Shree ambika global - Cart",
  "/wishlist": "Shree ambika global - Wishlist",
  "/blog": "Shree ambika global - Blog",
  "/blog-sidebar": "Shree ambika global - Blog Sidebar",
  "/contact": "Shree ambika global - Contact Us",
  "/faq": "Shree ambika global - FAQ",
  "/login": "Shree ambika global - Login / Register",
};

const getTitleFromPath = (pathname) => {
  // Check exact match in routeTitles
  if (routeTitles[pathname]) {
    return routeTitles[pathname];
  }

  // Check prefix matches for dynamic routes (e.g. blog-details/:id)
  if (pathname.startsWith("/blog-details/")) {
    return "Shree ambika alobal - Blog Details";
  }

  // Fallback: Parse pathname dynamically
  const segments = pathname.split("/").filter(Boolean);
  if (segments.length > 0) {
    let lastSegment = segments[segments.length - 1];
    
    // If the last segment is a number (ID), use the previous segment
    if (segments.length > 1 && !isNaN(lastSegment)) {
      lastSegment = segments[segments.length - 2];
    }

    const formatted = lastSegment
      .replace(/[-_]/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());

    if (formatted.toLowerCase() === "faq") {
      return "Shree Ambika Global - FAQ";
    }

    return `Shree Ambika Global - ${formatted}`;
  }

  return "Shree Ambika Global";
};

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    // Set dynamic page title
    document.title = getTitleFromPath(pathname);
  }, [pathname]);

  return null;
}

